import { makePersonLogoCellTemplate, urlCellTemplate } from "../framework/tabulars";

export function instructorsWithFixedColumnOverrides() {
  return {
    instructor_logo_url: {
      cellTemplate: makePersonLogoCellTemplate({
        idField: "instructor_id",
        firstnameField: "instructor_firstname",
        lastnameField: "instructor_lastname",
      }),
      fixed: true,
      visible: true,
      visibleIndex: 1,
      allowSorting: false,
      allowFiltering: false,
      width: 50,
      alignment: "right",
    },
    instructor_lastname: {
      cellTemplate: instructorUrlCellTemplate,
      fixed: true,
      visible: true,
      visibleIndex: 2,
      sortIndex: 0,
      sortOrder: "asc",
    },
    instructor_firstname: {
      cellTemplate: instructorUrlCellTemplate,
      fixed: true,
      visible: true,
      visibleIndex: 3,
    },
    instructor_second_lastname: {
      cellTemplate: instructorUrlCellTemplate,
      fixed: true,
    },
    instructor_birthdate: {
      cellTemplate: dateCellTemplate,
    },
    instructor_bio: {
      cellTemplate: longTextCellTemplate,
    },
    instructor_diploma: {
      cellTemplate: longTextCellTemplate,
    },
    instructor_status: {
      allowFiltering: false,
      visible: true,
    },
    instructor_tags: {
      cellTemplate: tagsCellTemplate,
    },
  };
}

export function instructorsColumnOverrides() {
  return {
    instructor_logo_url: {
      cellTemplate: makePersonLogoCellTemplate({
        idField: "instructor_id",
        firstnameField: "instructor_firstname",
        lastnameField: "instructor_lastname",
      }),
      visible: true,
      visibleIndex: 1,
      allowSorting: false,
      allowFiltering: false,
      width: 50,
      alignment: "right",
    },
    instructor_lastname: {
      cellTemplate: instructorUrlCellTemplate,
      visible: true,
      visibleIndex: 2,
    },
    instructor_firstname: {
      cellTemplate: instructorUrlCellTemplate,
      visible: true,
      visibleIndex: 3,
    },
    instructor_second_lastname: {
      cellTemplate: instructorUrlCellTemplate,
    },
    instructor_birthdate: {
      cellTemplate: dateCellTemplate,
    },
    instructor_bio: {
      cellTemplate: longTextCellTemplate,
    },
    instructor_diploma: {
      cellTemplate: longTextCellTemplate,
    },
    instructor_status: {
      allowFiltering: false,
      allowHeaderFiltering: true,
    },
    instructor_tags: {
      cellTemplate: tagsCellTemplate,
    },
  };
}

function dateCellTemplate(container, options) {
  if (options.displayValue) {
    let date = options.displayValue.toLocaleString("fr", { year: "numeric", month: "numeric", day: "numeric" });
    $(`<span>${date}</span>`).appendTo(container);
  }
}

function longTextCellTemplate(container, options) {
  let shortVersion = _.truncate(options.displayValue, {
    length: 20,
  });
  $(`<span title="${options.displayValue}">${shortVersion}</span>`).appendTo(container);
}

function tagsCellTemplate(container, options) {
  if (options.displayValue) {
    const tags = options.displayValue.map((x) => `<span class='badge badge--xs has-bg-grey-120 has-text-white'>${x}</span>`);
    $(`<span>${tags.join(" ")}</span>`).appendTo(container);
  }
}

function instructorUrlCellTemplate(container, options) {
  const url = p`/instructors/${options.row.data.instructor_id}/edit`;
  const title = options.displayValue;
  urlCellTemplate(url, title, container);
}
